import { ButtonLink } from "@ui/ButtonLink";
import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";

type Props = {
	symbol: string;
	title: string;
	body: string;
	/** Owner-only: where to go to fill the gap. */
	action?: { label: string; href: string };
};

export const AskPageEmptyState = (props: Props) => (
	<Card theme="grey" borderRadius="large">
		<HStack align="center" justify="space-between" spacing="large">
			<HStack align="start" spacing="medium">
				<MaterialSymbol symbol={props.symbol} color="fg3" />
				<VStack spacing="small">
					<Text weight="semi-bold" color="ink">
						{props.title}
					</Text>
					<Text size="small" color="fg2">
						{props.body}
					</Text>
				</VStack>
			</HStack>
			<Show when={props.action}>
				{(action) => (
					<ButtonLink href={action().href} variant="secondary" symbol="edit">
						{action().label}
					</ButtonLink>
				)}
			</Show>
		</HStack>
	</Card>
);
